import { render } from "./MultiCustomers.vue?vue&type=template&id=085cb392&scoped=true"
import script from "./MultiCustomers.vue?vue&type=script&lang=js"
export * from "./MultiCustomers.vue?vue&type=script&lang=js"

import "./MultiCustomers.vue?vue&type=style&index=0&id=085cb392&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085cb392"]])

export default __exports__